import { cn } from "../../lib/utils";
import { SITE } from "../../lib/site";

/**
 * Brand logo — the client's amber house-and-plug mark (public/logo.png, Volt
 * Amber #E8A23D on transparent). A single full-colour PNG used as-is in both
 * light and dark themes; the amber reads well on the light header and the dark
 * header/hero alike. Intrinsic size 1478×1005 — scale via the `className`
 * height (width follows the aspect ratio).
 */
export function Logo({ className }: { className?: string }) {
  return (
    <img
      src="/logo.png"
      alt={`${SITE.name} logo`}
      width={1478}
      height={1005}
      className={cn("inline-block w-auto", className)}
    />
  );
}

/** Small mark alias (kept for existing imports); same logo. */
export function LogoMark({ className }: { className?: string }) {
  return <Logo className={cn("h-8", className)} />;
}
